import { Pipe, PipeTransform } from '@angular/core';
import { ApprovalStatus } from '../../enums/approval/approval.enum';

@Pipe({
  name: 'approvalStatusPipe'
})
export class ApprovalStatusPipe implements PipeTransform {
  transform(value: ApprovalStatus): string {
    switch (value) {
      case ApprovalStatus.Pending:
        return 'Pending';
        case ApprovalStatus.PartiallyApproved:
          return 'Partially Approved';
        case ApprovalStatus.Approved:
          return 'Approved';
        case ApprovalStatus.Declined:
          return 'Declined';  
        case ApprovalStatus.Queued:
          return 'Queued';
      default:
        return 'Initiated';
    }
  }
}
